import { FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/completingActions';
import { FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/startingActions';
import { FINTRAC_STR_TRANSACTION_SUSPICIOUS_TRANSACTION_DETAILS_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/suspiciousTransactionDetails';
import { FintracFormSection } from 'app/modules/fintracStr/models';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

export const FINTRAC_STR_TRANSACTIONS_TAB_SECTION: FintracFormSection = {
  type: 'tabSection',
  repeatable: true,
  label: 'Transactions',
  name: 'transactions',
  mustExistInPayload: true,
  mustHaveValueIfExist: true,
  virtualizeOptions: {
    estimateSize: () => 1200, // approximate height of a default section
    gap: 16,
    overscan: 5,
  },
  defaultNumOfEntries: 1,
  fields: [
    {
      type: U21FormFieldTypes.TEXT,
      name: 'reportingEntityLocationId',
      label: 'Reporting entity location ID',
      required: true,
      mustExistInPayload: true,
      mustHaveValueIfExist: false,
      formToPayloadValueConversion: (formValue) => {
        return {
          reportingEntityLocationId: formValue?.toString(),
        };
      },
    },
    FINTRAC_STR_TRANSACTION_SUSPICIOUS_TRANSACTION_DETAILS_FIELDS,
    FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_FIELDS,
    FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_FIELDS,
  ],
};
